import React, { useEffect, useRef, useState } from 'react';
import Moveable from 'react-moveable';
import  {
	StyledPhotoEditorStickerContainer,
	StyledPhotoEditorStickerImg,
	StyledPhotoEditorStickerDelete,
} from 'components/Selfiebooth/PhotoEditor/styled'
import { StickerSelfieBoothType } from '../../../types/selfiebooth';
import { FiX } from 'react-icons/fi';

interface StickerProps {
	sticker: StickerSelfieBoothType;
	onUpdate: (id: string, p: { rotation?: number; x?: number; y?: number; width?: number; height?: number }) => void;
	onDelete: (id: string) => void;
	onSelect: (id: string) => void;
	isSelected: boolean;
}

const Sticker = ({ sticker, onUpdate, onDelete, onSelect, isSelected }: StickerProps) => {
	const ref = useRef<HTMLDivElement>(null);
	const [target, setTarget] = useState<HTMLElement | null>(null);

	useEffect(() => {
		if (ref.current) {
			setTarget(ref.current);
		}
	}, []);

	return (
		<>
			<div
				style={{
					position: 'absolute',
					top: sticker.y,
					left: sticker.x,
					width: sticker.width || 100,
					height: sticker.height || 100,
					transform: `rotate(${sticker.rotation || 0}deg)`,
					zIndex: 10000
				}}
				ref={ref}
				onMouseDown={() => onSelect(sticker.id)}
			>
				<StyledPhotoEditorStickerContainer $width={sticker.width} $height={sticker.height}>
					<StyledPhotoEditorStickerImg src={sticker.url} alt="sticker" />
					{isSelected && (
						<StyledPhotoEditorStickerDelete onClick={() => onDelete(sticker.id)}>
							<FiX />
						</StyledPhotoEditorStickerDelete>
					)}
				</StyledPhotoEditorStickerContainer>
			</div>

			{isSelected && target && (
				<Moveable
					target={target}
					draggable={true}
					resizable={true}
					rotatable={true}
					keepRatio={true}
					throttleDrag={0.1}
					throttleResize={0.1}
					renderDirections={["nw", "ne", "sw", "se"]}
					onDrag={({ target, left, top }) => {
						const container = ref.current?.parentElement;
						if (!container) return;

						const containerWidth = container.clientWidth;
						const containerHeight = container.clientHeight;
						const stickerWidth = sticker.width || 100;
						const stickerHeight = sticker.height || 100;

						const newX = Math.max(0, Math.min(left, containerWidth - stickerWidth));
						const newY = Math.max(0, Math.min(top, containerHeight - stickerHeight));

						onUpdate(sticker.id, { x: newX, y: newY });
					}}
					onResize={({ width, height, direction, drag }) => {
						let newX = sticker.x;
						let newY = sticker.y;

						if (direction[0] === -1) {
							newX = sticker.x + (sticker.width - width);
						}

						if (direction[1] === -1) {
							newY = sticker.y + (sticker.height - height);
						}

						onUpdate(sticker.id, {
							width,
							height,
							x: newX,
							y: newY,
						});
					}}
					onRotate={({ beforeRotate }) => {
						onUpdate(sticker.id, { rotation: beforeRotate });
					}}
				/>
			)}
		</>
	);
};

export default Sticker;
